module.exports = __webpack_public_path__ + "img/arrow_top_rounded.ac58f21c.svg";